import { styled } from "@vitality-ds/system";
import baseStackStyles from "./styles/BaseStack.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseStack = styled("div", baseStackStyles);